// @flow
// eslint-disable-next-line import/no-mutable-exports
let isIOS = false;

if (typeof navigator !== 'undefined') {
  isIOS =
    [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].indexOf(navigator.platform) >= 0;

  // iPad iOS 13 pretends to be OSX so we test for "TouchEvent"
  if (navigator.userAgent.indexOf('Mac') > -1) {
    try {
      document.createEvent('TouchEvent');
      isIOS = true;
      // eslint-disable-next-line no-empty
    } catch (e) {}
  }
}

export default isIOS;
